var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentBrand)?_c('div',{staticClass:"product-header bg-img",class:{ brandProductHeader: _vm.domainBasedBrand },attrs:{"id":"fixed_cls"}},[_c('div',[(!_vm.getFilteredOffers.length)?_c('offers-single-slider',{attrs:{"offers":_vm.all_brand_website_banners}}):_c('offers-slider',{attrs:{"offers":_vm.getFilteredOffers}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }